import { BaseAPI } from './BaseAPI.js'
import { CampaignDisposition } from '../types/index.js'

export default class CampaignDispositionAPI extends BaseAPI<CampaignDisposition> {
  override get resource(): string {
    return '/campaignDispositions'
  }
}
